
export const LOGS_DESTINATION = {
  NULL: "NULL",
  CLIENT_LOGGER: "CLIENT_LOGGER",
  DEBUG: "DEBUG"
};

export const MIN_WEBSOCKET_LIFETIME_MS = 300000;
export const HEARTBEAT_INTERVAL_MS = 10000;
export const WEBSOCKET_URL_VALID_TIME_MS = 85000;
export const TOPIC_SUBSCRIPTION_RETRY_INTERVAL_MS = 500;
export const MAX_CONSECUTIVE_FAILED_SUB_ATTEMPTS = 5;
export const MAX_WAIT_TIME_SUB_REQUEST_WITH_NO_RESPONSE_MS = 1000;
export const MAX_CONSECUTIVE_SUB_REQUEST_WITH_NO_RESPONSE = 3;
export const NETWORK_CONN_CHECK_INTERVAL_MS = 250;
export const WEBSOCKET_REINIT_JITTER = 0.3;
export const WEBSOCKET_RETRY_RATE_MS = 2000;
export const MAX_WEBSOCKET_RETRY_RATE_MS = 30000;

export const NETWORK_FAILURE = 'NetworkingError';

export const LOG_MESSAGES = {
  DEFAULT_PREFIX: "AMZ_WEB_SOCKET_MANAGER:",
  NETWORK_OFFLINE: "Network offline",
  NETWORK_ONLINE: "Network online, connecting to WebSocket server",
  NETWORK_OFFLINE_WARNING: "Network offline, ignoring this getWebSocketConnConfig request",
  NO_HEARTBEAT: "Heartbeat response not received",
  HEARTBEAT_RECEIVED: "Heartbeat response received",
  SENDING_HEARTBEAT: "Sending heartbeat",
  FAILED_HEARTBEAT: "Failed to send heartbeat since WebSocket is not open",
  WEBSOCKET_CONNECTION_ESTABLISHED: "WebSocket connection established!",
  WEBSOCKET_CONNECTION_CLOSED: "WebSocket connection is closed",
  WEBSOCKET_CONNECTION_ERROR: "WebSocketManager Error, error_event: ",
  WEBSOCKET_REINITIALIZATION: "Scheduling WebSocket reinitialization, after delay ",
  WEBSOCKET_REINITIALIZATION_TIMEOUT: "WebSocket URL cannot be used to establish connection",
  WEBSOCKET_INITIALIZATION_FAILED: "WebSocket Initialization failed - Terminating and cleaning subscriptions",
  WEBSOCKET_TERMINATED: "Terminating WebSocket Manager",
  WEBSOCKET_NEW_CONNECTION: "Fetching new WebSocket connection configuration",
  WEBSOCKET_CONNECTION_SUCCESS: "Successfully fetched webSocket connection configuration",
  WEBSOCKET_CONNECTION_FAILURE: "Failed to fetch webSocket connection configuration",
  WEBSOCKET_CONNECTION_RETRY: "Retrying fetching new WebSocket connection configuration",
  WEBSOCKET_INIT: "Initializing Websocket Manager",
  WEBSOCKET_INIT_FAILURE: "Initializing Websocket Manager Failed!",
  WEBSOCKET_CONNECTION_OPEN: "Websocket connection open",
  WEBSOCKET_CONNECTION_CLOSE: "Websocket connection close",
  WEBSOCKET_CONNECTION_GAIN: "Websocket connection gain",
  WEBSOCKET_CONNECTION_LOST: "Websocket connection lost",
  WEBSOCKET_SUBSCRIPTION_FAILURE: "Websocket subscription failure",
  WEBSOCKET_RESET: "Reset Websocket state",
  WEBSOCKET_MESSAGE_ERROR: "WebSocketManager Message Error",
  WEBSOCKET_MESSAGE_RECEIVED: "Message received for topic ",
  WEBSOCKET_MESSAGE_INVALID: "Invalid incoming message",
  WEBSOCKET_MESSAGE_SUCCESS: "WebsocketManager invoke callbacks for topic success ",
};

export const ROUTE_KEY = {
  SUBSCRIBE: "aws/subscribe",
  UNSUBSCRIBE: "aws/unsubscribe",
  HEARTBEAT: "aws/heartbeat"
};

export const CONN_STATE = {
  CONNECTED: "connected",
  DISCONNECTED: "disconnected"
};
